import { useEffect, lazy, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import { WhatsAppFloat } from '@/components';
import Layout from '@/components/layout';
import { PageSkeleton } from '@/components/ui/Loading';
import { CheckoutSuccessPreviewPage } from '@/pages/Budget/Checkout';

import 'react-toastify/dist/ReactToastify.css';
import { Analytics } from '@vercel/analytics/react';

// Lazy loading de rotas para melhor performance
const BudgetSteps = lazy(() => import('@/components/BudgetSteps'));
const Orders = lazy(() => import('@/pages/Orders'));
const BackofficeRoutes = lazy(() => import('@/pages/Backoffice'));
const NotFound = lazy(() => import('@/pages/NotFound'));

function DismissToastsOnRouteChange() {
  const { pathname, search } = useLocation();
  // Dismiss toasts when either pathname or search params changee.
  useEffect(() => {
    toast.dismiss();
    toast.clearWaitingQueue && toast.clearWaitingQueue();
  }, [pathname, search]);
  return null;
}

function ConditionalWhatsApp() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/backoffice')) return null;
  return <WhatsAppFloat />;
}

function App() {
  return (
    <Router>
      <Suspense fallback={<PageSkeleton />}>
        <Routes>
          <Route
            path='/preview-csat-modal-final'
            element={<CheckoutSuccessPreviewPage />}
          />
          <Route path='/backoffice/*' element={<BackofficeRoutes />} />
          <Route element={<Layout />}>
            {/* Todas as páginas de orçamento agora estão sob / com step parameter */}
            <Route path='/' element={<BudgetSteps />} />
            <Route path='/meus-pedidos' element={<Orders />} />
            <Route path='*' element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
      <Analytics />
      <DismissToastsOnRouteChange />
      <ConditionalWhatsApp />
      <ToastContainer
        position='top-right'
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        theme='light'
        limit={3}
        closeButton={false}
      />
    </Router>
  );
}

export default App;
